import { createActions } from 'reduxsauce';

var _createActions = createActions({
  getRewardsAction: function getRewardsAction() {
    return {
      type: 'REWARDS_GET_REWARDS_ACTION'
    };
  },
  getBonusRewardsAction: function getBonusRewardsAction() {
    return {
      type: 'REWARDS_GET_BONUS_REWARDS_ACTION'
    };
  },
  getPegPointsAction: function getPegPointsAction(points) {
    return {
      type: 'REWARDS_GET_PEG_POINTS_ACTION',
      userPegs: points
    };
  },
  resetPegPointsAction: function resetPegPointsAction(points) {
    return {
      type: 'REWARDS_RESET_PEG_POINTS_ACTION',
      userPegs: points
    };
  },
  getRecommendedRewardsRedemptionAction: function getRecommendedRewardsRedemptionAction(recommendedRewardsRedemptionResponse) {
    return {
      type: 'REWARDS_GET_RECOMMENDED_REWARDS_REDEMPTION_ACTION',
      recommendedRewardsRedemptionResponse: recommendedRewardsRedemptionResponse
    };
  },
  getRewardsRedemptionAction: function getRewardsRedemptionAction(rewardsRedemptionResponse) {
    return {
      type: 'REWARDS_GET_REWARDS_REDEMPTION_ACTION',
      rewardsRedemptionResponse: rewardsRedemptionResponse
    };
  },
  getCustomRewardsRedemptionAction: function getCustomRewardsRedemptionAction(customRewardsRedemptionResponse) {
    return {
      type: 'REWARDS_GET_CUSTOM_REWARDS_REDEMPTION_ACTION',
      customRewardsRedemptionResponse: customRewardsRedemptionResponse
    };
  },
  redeemRewardsAction: function redeemRewardsAction(redeemedRewards) {
    return {
      type: 'REWARDS_REDEEM_REWARDS_ACTION',
      redeemedRewards: redeemedRewards
    };
  },
  resetRewardsRedemptionAction: function resetRewardsRedemptionAction() {
    return {
      type: 'REWARDS_RESET_REWARDS_REDEMPTION_ACTION'
    };
  },
  resetRewardsRedemptionModule: function resetRewardsRedemptionModule(json) {
    return {
      type: 'REWARDS_RESET_REWARDS_REDEMPTION_MODULE',
      cart: json
    };
  },
  storeLastCustomRewardsRequest: function storeLastCustomRewardsRequest(json) {
    return {
      type: 'REWARDS_STORE_LAST_CUSTOM_REWARDS_REQUEST',
      customRewardsRequest: json
    };
  },
  storeLastRemovedItem: function storeLastRemovedItem(itemKey) {
    return {
      type: 'REWARDS_STORE_LAST_REMOVED_ITEM',
      lastRemovedItem: itemKey
    };
  },
  processingRewards: function processingRewards(_processingRewards) {
    return {
      type: 'REWARDS_PROCESSING_REWARDS',
      processingRewards: _processingRewards
    };
  }
}, {
  prefix: 'REWARDS_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};